import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import type { CreateFromOrdersOutput } from '@/lib/api/subscriptions';

interface ResultsStepProps {
  results: CreateFromOrdersOutput;
}

export function ResultsStep({ results }: ResultsStepProps) {
  const { t } = useTranslation('subscriptions');

  const created = results.filter((r) => r.status === 'created');
  const notCreated = results.filter((r) => r.status !== 'created');

  return (
    <div className="space-y-4">
      <p className="text-sm font-medium">
        {t('createFromOrders.results.summary', { count: created.length, total: results.length })}
      </p>

      {notCreated.length > 0 ? (
        <div className="max-h-64 overflow-y-auto rounded-md border">
          <Table>
            <TableBody>
              {notCreated.map((row) => (
                <TableRow key={row.orderId}>
                  <TableCell className="font-mono text-xs">{row.orderId}</TableCell>
                  <TableCell>
                    <Badge variant={row.status === 'failed' ? 'destructive' : 'secondary'}>
                      {row.reason
                        ? t(`createFromOrders.reasons.${row.reason}`, { defaultValue: row.reason })
                        : (row.error ?? row.status)}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : null}
    </div>
  );
}
